import api from './api';
import {
  Property,
  PropertyFilters,
  PropertyStats,
  AvailabilitySummary,
  Unit,
} from '@/types/property.types';
import { PaginatedResponse } from '@/types';

export const propertiesService = {
  // Get all properties (sales kits) with filters and pagination
  getAll: (filters?: PropertyFilters, page = 1, limit = 20) =>
    api.get<PaginatedResponse<Property>>('/sales-kits', {
      params: { ...filters, page, limit },
    }),

  // Get single property by ID with units
  getById: (id: string) =>
    api.get<Property>(`/sales-kits/${id}`),

  // Search properties
  search: (query: string) =>
    api.get<Property[]>('/sales-kits/search', { params: { q: query } }),

  // Get property statistics
  getStats: () =>
    api.get<PropertyStats>('/sales-kits/stats'),

  // Get availability summary for a property
  getAvailability: (id: string) =>
    api.get<AvailabilitySummary>(`/sales-kits/${id}/availability`),

  // Create a new property
  create: (data: Partial<Property>) =>
    api.post<Property>('/sales-kits', data),

  // Update property
  update: (id: string, data: Partial<Property>) =>
    api.put<Property>(`/sales-kits/${id}`, data),

  // Delete property
  delete: (id: string) =>
    api.delete(`/sales-kits/${id}`),

  // Add unit to property
  addUnit: (propertyId: string, data: Partial<Unit>) =>
    api.post<Unit>(`/sales-kits/${propertyId}/units`, data),

  // Update unit
  updateUnit: (propertyId: string, unitId: string, data: Partial<Unit>) =>
    api.put<Unit>(`/sales-kits/${propertyId}/units/${unitId}`, data),

  // Book unit
  bookUnit: (propertyId: string, unitId: string, leadId: string) =>
    api.post<Unit>(`/sales-kits/${propertyId}/units/${unitId}/book`, {
      lead_id: leadId,
    }),
};

export default propertiesService;
